/**
 * Registry Instances
 * 
 * This file creates and configures singleton instances of all registries.
 */
import { ElementRegistry } from './elements/elementRegistry';
import { EntityRegistry } from './entities/entityRegistry';
import { MediaRegistry } from './media/mediaRegistry';
import { ElementAttributeRegistry } from './elements/elementAttributeMapping';
import { registerElements } from './elements/elements.registered';
import { registerEntities } from './entities/entities.registered';
import { registerMediaTypes } from './media/media.registered';
import { registerElementAttributes } from './elements/elementAttributes.registered';

/**
 * Singleton instance of the element registry
 */
export const elementRegistry = new ElementRegistry();

/**
 * Singleton instance of the entity registry
 */
export const entityRegistry = new EntityRegistry();

/**
 * Singleton instance of the media registry
 */
export const mediaRegistry = new MediaRegistry();

/**
 * Singleton instance of the element attribute registry
 */
export const elementAttributeRegistry = new ElementAttributeRegistry();

/**
 * Initialize all registries with their default registrations
 */
function initializeRegistries(): void {
  registerElements(elementRegistry);
  registerEntities(entityRegistry);
  registerMediaTypes(mediaRegistry);
  registerElementAttributes(elementAttributeRegistry);
}

// Initialize registries immediately
initializeRegistries();